import React, { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess } from "services/toast.service";
import { handleError } from "utils";
import { getAccessToken } from "utils";

import { useHistory, useLocation, useParams } from "react-router-dom";
import Button from "components/Button";
import { API_BASE_URL } from "config/constants";
import Modal from "react-modal";
import { ROLES } from "config/roles";
import { getUser } from "utils";

const AddInvoices = ({ color }) => {
  const { pathname, state } = useLocation();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [manager, setmanager] = useState([]);
  const [clients, setClients] = useState([]);
  const user = getUser();
  const [assignedManager, setassignedManager] = useState({
    assign: "",
  });
  const [gettingData, setGettingData] = useState(false);

  const { data } = state || {};
  const isUpdate = pathname === "/admin/update-invoice";
  const history = useHistory();

  if (isUpdate && !data) {
    history.goBack();
  }

  const [approveid, setapproveid] = useState();

  const [submitClick, setSubmitClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState(
    data || {
      accountName: ([ROLES.Advertizer, ROLES.Publisher].includes(user.role)) ? user.name: "",
      description: "",
      period: "",
      amount: "",
      status: "",
    }
  );

  const onChange = (e) => {
    setInvoice({ ...invoice, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    if (
      !invoice.accountName ||
      !invoice.description ||
      !invoice.period ||
      !invoice.amount ||
      !invoice.status
    )
      return false;
    return true;
  };

  const getClient = async () => {
    try {
      const responce = await axios.get(`${API_BASE_URL}/user?page=1`, {
        method: "GET",
        headers: {
          authorization: getAccessToken(),
        },
      });
      const apiData = responce.data;
      console.log("client is ", apiData);
      setClients(apiData.result.data.result.filter(e => [ROLES.Publisher, ROLES.Advertizer].includes(e.role)));
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    getClient();
  }, []);

  const handleClick = () => {
    setSubmitClick(true);
    if (!isValid()) return;
    if (isUpdate) {
      updateClient(invoice);
    } else {
      addInvoice(
        invoice.accountName,
        invoice.description,
        invoice.period,
        invoice.amount,
        invoice.status
      );
    }
  };

  const onapp = (e) => {
    setassignedManager({ ...assignedManager, [e.target.name]: e.target.value });
  };

  const getManagers = async () => {
    try {
      setGettingData(true);
      const response = await axios.get(
        `${API_BASE_URL}/user/all_account_managers`,
        {
          method: "GET",
          headers: {
            authorization: getAccessToken(),
          },
        }
      );
      setGettingData(false);
      const apiData = response.data;
      setmanager(apiData.result.data);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  console.log(manager);
  useEffect(() => {
    getManagers();
  }, []);

  const addInvoice = async (
    accountName,
    description,
    period,
    amount,
    status
  ) => {
    try {
      setLoading(true);
      let account;
      if(!([ROLES.Advertizer, ROLES.Publisher].includes(user.role))) {
        account = JSON.parse(accountName);
      } else {
        account = user;
      }
      const response = await axios.post(
        `${API_BASE_URL}/invoice`,
        {
          accountName: account.name,
          assignedTo: account.assignedTo,
          assignedToId: account.assignedToId,
          userId: account._id,
          description,
          period,
          amount,
          status,
        },
        {
          headers: {
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/invoices");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const updateClient = async (dataToUpdate) => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${API_BASE_URL}/invoice`,
        {
          id: data._id,
          ...dataToUpdate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/invoices");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">
              {isUpdate ? "Update Invoice" : "Add New Invoice"}

              <span className="text-blueGray-700 text-sm font-bold">
                {" "}
                (Fill in the details below)
              </span>
            </h6>
          </div>
        </div>
        <div className="flex-auto px-4 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase px-4">
              Add New Invoice
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Client Name
                  </label>
                  {(isUpdate || ([ROLES.Advertizer, ROLES.Publisher].includes(user.role))) ? (
                    <div className="block uppercase text-md  text-emerald-800 font-bold mt-2">
                      {invoice.accountName}
                    </div>
                  ) : (
                    <>
                      <select
                        onChange={onChange}
                        name="accountName"
                        value={invoice.accountName}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      >
                        <option value="" selected>
                          Choose
                        </option>
                        {clients.map((e, index) => (
                          <option key={index} value={JSON.stringify(e)}>
                            {e.name}
                          </option>
                        ))}
                      </select>
                      {submitClick && !invoice.accountName && (
                        <div className="text-red-500 text-sm mt-1 font-semibold">
                          Client Name is required!
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Description / Website
                  </label>
                  <input
                    type="text"
                    value={invoice.description}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="description"
                    onChange={onChange}
                  />
                  {submitClick && !invoice.description && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Description / Website is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Period
                  </label>
                  <input
                    type="text"
                    value={invoice.period}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    defaultValue=""
                    name="period"
                    onChange={onChange}
                  />
                  {submitClick && !invoice.period && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Period is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Amount
                  </label>
                  <input
                    type="number"
                    value={invoice.amount}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    defaultValue=""
                    name="amount"
                    onChange={onChange}
                  />
                  {submitClick && !invoice.amount && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Amount is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Payment Status
                  </label>
                  {/* <input
                    type="text"
                    value={invoice.status}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    defaultValue=""
                    name="status"
                    onChange={onChange}
                  /> */}

                  <select
                    onChange={onChange}
                    name="status"
                    value={invoice.status}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    <option value="" selected>
                      Choose
                    </option>
                    {["Pending", "Paid", "Cancelled"].map((e, index) => (
                      <option key={index} value={e}>
                        {e}
                      </option>
                    ))}
                  </select>
                  {submitClick && !invoice.status && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Payment Status is required!
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="px-4">
              <Button
                title={isUpdate ? "UPDATE INVOICE" : "ADD NEW INVOICE"}
                handleClick={handleClick}
                loading={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddInvoices;
